<template>
  <nav class="border-b fixed top-0 lg:w-[83%] w-[95%] z-30 bg-white">
    <section class="lg:w-[95%] m-auto py-4 flex justify-between items-center">
      <div class="flex items-center">
        <div class="block mr-2 lg:hidden" @click="openSidebar">
          <i class="pi pi-bars" style="font-size: 1rem"></i>
        </div>
        <div class="hidden md:block">
          <Breadcrumbs
            class="mt-0 ml-2"
            :crumbs="storedBreadcrumbs"
            :routeNamesToFilter="routeNamesToFilter"
          />
        </div>
        <div class="block md:hidden">
          <p class="text-xs font-semibold">{{ $route.name }}</p>
        </div>
      </div>

      <div class="flex items-center gap-x-4">
        <!-- <div>
          <img src="@/assets/svg/notification.svg" class="w-6 lg:w-7" />
        </div> -->
        <LogoutModal :handleOk="handleOk" :isOpen="isOpen" />

        <!-- <div
          class="bg-[var(--grey100)] rounded-full flex items-center lg:gap-x-4 gap-x-1 py-2 lg:px-4 px-2 lg:text-sm text-xs"
        > -->
        <!-- <img src="@/assets/svg/avatar.svg" class="w-5 lg:w-6" />
          <p>{{ userInfo.fullName }}</p> -->
        <div>
          <a-dropdown placement="bottomRight" :trigger="['click']">
            <a class="ant-dropdown-link" @click.prevent>
              <div
                class="bg-[var(--grey100)] rounded-full flex items-center lg:gap-x-3 gap-x-1 py-2 lg:px-4 px-2 lg:text-sm text-xs cursor-pointer"
              >
                <img
                  src="@/assets/svg/defaultAvatar.svg"
                  class="w-5 lg:w-6"
                  v-if="userInfo.avatar === '' || !userInfo.avatar"
                />
                <img
                  :src="userInfo.avatar"
                  class="w-5 h-5 rounded-full lg:w-6 lg:h-6"
                  v-else
                />
                <p>{{ userInfo.fullName }}</p>
                <img class="h-4" src="@/assets/svg/Arrow-Down.svg" />
              </div>
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item
                  class="flex items-center px-2 py-1 text-xs text-center"
                  key="0"
                  @click="logout"
                >
                  <!-- <img class="inline h-5 mr-2" src="@/assets/svg/edit.svg" /> -->

                  <span class="font-semibold text-red-400 text">Sign Out</span>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
        <!-- </div> -->
      </div>
    </section>
  </nav>
</template>

<script>
// libraries
import { useToast } from "vue-toastification";
import authService from "@/services/auth-service.js";
import { mapGetters } from "vuex";

//ui
import Breadcrumbs from "@/components/UI/Breadcrumb/index.vue";

//components
import LogoutModal from "@/components/pages/Auth/LogoutModal.vue";

export default {
  name: "Navbar",

  components: {
    Breadcrumbs,
    LogoutModal,
  },
  data() {
    return {
      toast: useToast(),
      storedBreadcrumbs:
        JSON.parse(sessionStorage.getItem("breadCrumbs")) || [],
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserDetails",
    }),

    //Add sidebar menus here to avoid duplicating its breadcrumb
    routeNamesToFilter() {
      return this.$router.options.routes
        .filter((route) => route.isMajor == true)
        .map((route) => route.name);
    },
  },
  mounted() {
    function filterBreadcrumbs(breadcrumbs, routesNamesToFilter, routeName) {
      if (routesNamesToFilter.includes(routeName)) {
        // If the current routeName is in routesNamesToFilter, keep only that breadcrumb
        const matchingBreadcrumb = breadcrumbs.find(
          (item) => item.name === routeName
        );
        return matchingBreadcrumb ? [matchingBreadcrumb] : [];
      } else {
        // If the current routeName is not in routesNamesToFilter, clear all breadcrumbs
        // return [];
        // return breadcrumbs.filter((item) => item.name !== routeName);
        return breadcrumbs;
      }
    }

    const filteredBreadcrumbs = filterBreadcrumbs(
      this.storedBreadcrumbs,
      this.routeNamesToFilter,
      this.$route.name
    );

    this.storedBreadcrumbs = filteredBreadcrumbs;

    if (
      !this.storedBreadcrumbs.find((item) => item.name === this.$route.name)
    ) {
      this.storedBreadcrumbs.push({ name: this.$route.name });
    }

    sessionStorage.setItem(
      "breadCrumbs",
      JSON.stringify(this.storedBreadcrumbs)
    );
  },

  methods: {
    handleOk() {
      // console.log("closed modal");
      this.isOpen = false;
    },
    logout() {
      // console.log("opened modal");
      this.isOpen = true;
    },

    //utilities
    openSidebar() {
      this.$store.dispatch("openSidebar");
    },
  },
};
</script>

<style></style>
